import { Children, cloneElement, useEffect, useId } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import { StyledContainer, StyledTabLine } from './TabsContainer.styled';

export interface ITabsContainerProps {
	activeIndex: number;
	handlePrev: () => void;
	handleNext: () => void;
	setIndex: (index: number) => void;
}

const TabsContainer = ({
	activeIndex,
	handlePrev,
	handleNext,
	setIndex,
	children,
	...props
}: ITabsContainerProps & React.HTMLAttributes<HTMLDivElement>) => {
	const id = useId();
	useInputAction(InputAction.CommonTabNavLeft, () => {
		handlePrev();
	});
	useInputAction(InputAction.CommonTabNavRight, () => {
		handleNext();
	});

	useEffect(() => {
		const tabElement = document.getElementById(`tab${id}#${activeIndex}`);
		if (tabElement !== null) {
			tabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	}, [activeIndex]);

	useEffect(() => {
		const tabElement = document.getElementById(`tab${id}#${activeIndex}`);
		const lineElement = document.getElementById(`tab${id}#line`);
		if (tabElement !== null && lineElement !== null) {
			const tabWidth = window.getComputedStyle(tabElement).width;
			lineElement.style.setProperty('--width', tabWidth);
			lineElement.style.setProperty('--left', `${tabElement.offsetLeft}px`);
		}
	}, [activeIndex]);

	return (
		<StyledContainer {...props}>
			{Children.map(children, (child: any, index) => {
				return cloneElement(child, {
					id: `tab${id}#${index}`,
					onClick: () => {
						setIndex(index);
						playSound(Sound.ClickButton);
					},
					$selected: index == activeIndex,
				});
			})}
			<StyledTabLine id={`tab${id}#line`} />
		</StyledContainer>
	);
};

export { TabsContainer };
